import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import utils from 'utils';
import { useTranslation } from 'react-i18next';
import { ShareableLinkAnalyticsFileEntry } from 'models/ShareableLink';
import DataRoomNodePreview from 'router/subrouters/Dash/subrouters/private/components/PortfolioDataRoomNodes/components/DataRoomNodePreview';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { Q_AND_A_SIDES } from 'router/subrouters/DataRoom/models/QAndA';
import EyeIcon from 'icons/Eye.icon';
import DownloadIcon from 'icons/Download.icon';
import ClockIcon from 'icons/Clock.icon';

import './SecureLinkFile.styles.scss';

type SecureLinkFileProps = {
  className?: string;
  file: ShareableLinkAnalyticsFileEntry;
  siblings?: ShareableLinkAnalyticsFileEntry[];
};

const SecureLinkFile: React.FC<SecureLinkFileProps> = (props) => {
  const { className, file, siblings = [] } = props;

  const classes = classNames('secure-link-file', className);

  const {
    dataRoom: { name, userId, dealRoomId },
  } = useContext(DataRoomContext);

  const {
    numberOfDownloads,
    numberOfSecondsSpent,
    numberOfViews,
    dataRoomNode,
  } = file || {};

  const { type, count } = useMemo(
    () => utils.timeSpentInSecondsHumanize(numberOfSecondsSpent, true),
    [numberOfSecondsSpent],
  );

  const { t } = useTranslation();

  const dataRoomNodesSiblings = useMemo(
    () => siblings.map(({ dataRoomNode }) => dataRoomNode),
    [siblings],
  );

  return (
    <div className={classes}>
      <DataRoomNodePreview
        node={dataRoomNode}
        dataRoomName={name}
        ownerId={userId}
        userSide={Q_AND_A_SIDES.SELL}
        siblings={dataRoomNodesSiblings}
        dealRoomId={dealRoomId}
      />

      <div className="stats">
        <span>
          <EyeIcon />
          {numberOfViews}
        </span>
        <span>
          <DownloadIcon />
          {numberOfDownloads}
        </span>
        <span>
          <ClockIcon />
          {t(`timeSpentInSecondsHumanizeShort.${type}`, { count })}
        </span>
      </div>
    </div>
  );
};

export default SecureLinkFile;
